import { render } from "./AgentFilesPage.vue?vue&type=template&id=369110b5&ts=true"
import script from "./AgentFilesPage.vue?vue&type=script&lang=ts"
export * from "./AgentFilesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__